// extracted by mini-css-extract-plugin
export default {"root":"_2s2s20VLWQsGuEAi6RMjQl","dragging":"_2WmCpNRF48Vqf9EwgQXWFs"};